import { sortCx } from "@/utils/cx";

export const styles = sortCx({
	common: {
		icon: "pointer-events-none text-fg-quaternary transition-[inherit] group-hover/button-group:text-fg-quaternary_hover group-selected/button-group:text-white group-hover/button-group:group-selected/button-group:text-white",
		root: [
			"group/button-group inline-flex h-max cursor-pointer items-center bg-primary font-semibold whitespace-nowrap text-secondary shadow-skeuomorphic ring-1 ring-primary outline-brand transition duration-100 ease-linear ring-inset",
			// Hover and focus styles
			"hover:bg-primary_hover hover:text-secondary_hover focus-visible:z-10 focus-visible:outline-2 focus-visible:outline-offset-2",
			// Disabled styles
			"disabled:cursor-not-allowed disabled:bg-primary disabled:opacity-50",
			// Selected styles
			"selected:z-10 selected:bg-brand-solid selected:text-white selected:ring-brand-solid selected:hover:bg-brand-solid_hover selected:hover:text-white selected:disabled:opacity-50",
		].join(" "),
	},

	sizes: {
		lg: {
			icon: "size-5",
			root: "gap-2 px-4.5 py-2.5 text-md not-last:pr-[calc(calc(var(--spacing)*4.5)+1px)] first:rounded-l-lg last:rounded-r-lg data-icon-leading:pl-4 data-icon-only:p-3",
		},
		md: {
			icon: "size-5",
			root: "gap-1.5 px-4 py-2.5 text-sm not-last:pr-[calc(calc(var(--spacing)*4)+1px)] first:rounded-l-lg last:rounded-r-lg data-icon-leading:pl-3.5 data-icon-only:px-3",
		},
		sm: {
			icon: "size-5",
			root: "gap-1.5 px-3.5 py-2 text-sm not-last:pr-[calc(calc(var(--spacing)*3.5)+1px)] first:rounded-l-lg last:rounded-r-lg data-icon-leading:pl-3 data-icon-only:p-2",
		},
	},
});
